import React from "react";
import "./MyButton.css";
import PulseLoader from "react-spinners/PulseLoader";

interface MyButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  visible?: boolean;
  isLoading?: boolean;
  variant?: "light" | "dark" | "secondary" | "transparent";
  isSubmit?: boolean;
}

export const MyButton: React.FC<MyButtonProps> = ({
  children,
  onClick,
  className = "",
  disabled = false,
  visible = true,
  isLoading = false,
  style = {},
  isSubmit,

  variant = "dark", // Default è dark, ovvero colorato
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (disabled || isLoading) {
      e.preventDefault();
      return;
    }
    onClick?.();
  };

  const buttonClass = `myBtn ${variant} my-rounded  py-3 my-2 d-flex justify-content-center align-items-center ${className} ${
    disabled || !visible ? "disabled" : ""
  }`;

  return (
    <button
      type={isSubmit ? "submit" : "button"}
      className={buttonClass}
      style={{
        ...style,
        opacity: visible ? 1 : 0,
        visibility: visible ? "visible" : "hidden",
        pointerEvents: visible && !isLoading ? "auto" : "none",
      }}
      onClick={handleClick}
    >
      {isLoading ? (
        <PulseLoader color={variant === "light" ? "#000" : "#fff"} size={10} />
      ) : (
        children
      )}
    </button>
  );
};
